export default {
  _formatData(value) {
    if (
      typeof value == "undefined" ||
      value == null ||
      value == "null" ||
      value == "undefined"
    ) {
      return "";
    }
    return value;
  },
  _checkUserType() {
    return new Promise((resolve, reject) => {
      this.$http({
        method: "get",
        url: this.$urlMapper.getuser + "?" + new Date().getTime(),
        data: "noredirect"
      }).then(res => {
        if (res.data.code == 10000) {
          resolve({
            type: "游客"
          });
        } else {
          if (res.data.type == 0) {
            resolve({
              type: "个人"
            });
          } else if (res.data.type == 1) {
            resolve({
              type: "法人"
            });
          } else {
            resolve({
              type: "游客"
            });
          }
        }
      });
    });
  },
  _isNullorEmpty(value) {
    if (
      typeof value == "undefined" ||
      value == null ||
      value == "" ||
      JSON.stringify(value) == "{}" ||
      JSON.stringify(value) == "[]"
    ) {
      return true;
    }
    return false;
  },
  _createUuid() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now();
    }
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
      c
    ) {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  },
  // 下载文件
  _filedownload(url, rest, type) {
    let actionType = type ? type : "GET";
    let form = $(
      "<form method='" + actionType + "' style='display:none;'></form>"
    );
    form.attr("action", url);
    rest.forEach(item => {
      let input = $("<input type='hidden'/>");
      input.attr("value", encodeURIComponent(item.value));
      input.attr("name", item.name);
      form.append(input);
    });
    form.appendTo($("body"));
    form.submit();
    form.remove();
  },
  _downLoad(url, fileName, method) {
    let xhr = new XMLHttpRequest();
    let requestType = method ? method : "GET";
    xhr.open(requestType, url, true); // 也可以使用POST方式，根据接口
    xhr.responseType = "blob"; // 返回类型blob
    // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
    xhr.onload = function() {
      // 请求完成
      if (this.status === 200) {
        let blob = new Blob([this.response]);
        if ("download" in document.createElement("a")) {
          // 支持a标签download的浏览器
          const link = document.createElement("a");
          link.download = fileName;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); // 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link); // 释放标签
        } else {
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      }
    };
    // 发送ajax请求
    xhr.send();
  },
  _getUrlParam(name) {
    let result = window.location.search.match(
      new RegExp("[?&]" + name + "=([^&]+)", "i")
    );
    if (result == null || result.length < 1) {
      return "";
    }
    return result[1];
  }
};



// WEBPACK FOOTER //
// ./qp/assets/js/Tools.js